import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import CloseIcon from "@mui/icons-material/Close";
import { AnyFalsy } from "underscore";

interface Props {
  openErrorModal: any;
  setOpenErrorModal: any;
  title: string;
  body?: string;
  setRefreshByErrorModal?: any;
  refreshByErrorModal?: any;
  filterCount?: number;
}

const EmptyOrErrorInput = (props: Props) => {
  const openErrorModal = props.openErrorModal;
  const setOpenErrorModal = props.setOpenErrorModal;
  const setRefreshByErrorModal = props.setRefreshByErrorModal;
  const refreshByErrorModal = props.refreshByErrorModal;
  const { t } = useTranslation(["operation"]);

  const onClickCloseDialog = () => {
    if (props?.filterCount && props.filterCount > 0) {
      setRefreshByErrorModal(!refreshByErrorModal);
    }

    setOpenErrorModal(false);
  };

  return (
    <Dialog
      open={openErrorModal}
      PaperProps={{
        sx: {
          minWidth: "900px !important",
          height: "250px",
          borderRadius: "4px",
        },
      }}
    >
      <DialogTitle>
        <Grid
          container
          alignItems="center"
          alignContent="center"
          direction="row"
        >
          <Grid xs item>
            <Stack direction="row" spacing={2} justifyContent="flex-start">
              <ReportProblemIcon
                style={{
                  width: "20px",
                  color: "#E20B0B",
                }}
              />
              <span className="ReportProblemTitle">{props.title}</span>
            </Stack>
          </Grid>
          <Grid
            xs
            item
            sx={{
              justifyContent: "flex-end",
              display: "flex",
            }}
          >
            <CloseIcon
              color="disabled"
              fontSize="small"
              onClick={onClickCloseDialog}
            />
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          <Stack
            component={"span"}
            spacing={0.5}
            sx={{ whiteSpace: "pre-wrap" }}
          >
            <span>{props.body}</span>
          </Stack>
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ background: "#F8F8F8" }}>
        <Stack direction="row" spacing={2} p={1} mr={1}>
          <Button
            sx={{
              maxWidth: "111px",
              maxHeight: "48px",
              minWidth: "111px",
              minHeight: "48px",
            }}
            variant="contained"
            color="accent"
            onClick={onClickCloseDialog}
          >
            <Typography
              sx={{
                textTransform: "capitalize",
                fontWeight: 700,
                lineHeight: 2.25,
                color: "white",
              }}
              variant="subtitle1"
            >
              {t("actionButtons.close")}
            </Typography>
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default EmptyOrErrorInput;
